import PanelInvitarAmigos from './PanelInvitarAmigos';
export default PanelInvitarAmigos;
